import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOrdersCancelParams, TypePostOrdersCancelResponse } from '~/types/delivery-agency.types';

/**
 * [배송 주문 관리] 주문 취소 API
 */
const fetchPostOrdersCancel = async (
  params: TypePostOrdersCancelParams
): Promise<TypePostOrdersCancelResponse['data']> => {
  const { data } = await axiosInstance.post<TypePostOrdersCancelResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_ORDERS_CANCEL,
    params
  );
  return data.data;
};

/**
 * [배송 주문 관리] 주문 취소 Mutation Hook
 */
export const usePostOrdersCancelMutation = () => {
  return useMutation<TypePostOrdersCancelResponse['data'], TypeErrorResponseData['error'], TypePostOrdersCancelParams>({
    mutationFn: fetchPostOrdersCancel,
    meta: { silent: true },
  });
};
